<template lang='pug'>
  v-container(fill-height)
    v-row
      v-col
        v-row
          v-col(align='center')
            h1.text-h4.blue-grey--text.text--darken-1 Forgot Password?
            h1.text-subtitle-1.blue-grey--text.text--darken-2 Request a password reset link via email below.
        v-row
          v-col(md='6' offset-md='3' sm='8' offset-sm='2')
            form#requestForm(@submit.prevent='request').mr-4.ml-4
              v-text-field(label='Email'
                prepend-icon='email'
                v-model='email'
                type='email'
                required)
              v-row(justify='end')
                v-btn.flush-right(color='primary'
                  :disabled='disableButton'
                  type='submit')
                  | Request Reset
            v-row.ma-4
              v-col.text-center
                v-btn(text color='primary' to='/signin')
                  | Sign In
              v-col.text-center
                v-btn(text color='primary' href='mailto:sales@bionicmetrics.com') Create Account
</template>

<script>
import _ from 'lodash';
import Notifications from '../services/notification.service';
import External from '../api/external';

export default {
  name: 'Request',
  methods: {
    async request() {
      this.disableButton = true;
      try {
        await External.request(this.email);
        Notifications.toast(`Reset email successfully sent to ${this.email}`);
        this.$router.push('/signin');
      } catch (e) {
        this.error(e);
      } finally {
        this.disableButton = false;
      }
    },
    error(error) {
      if (_.get(error, 'response.status') === 404) {
        return Notifications.alert(`No user found with email ${this.email}`);
      }
      return console.error(error);
    }
  },
  data() {
    return {
      email: null,
      disableButton: false
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
